@app.animation '.collapsible', ->
  addClass: (element, className, doneFn) ->
    if className == 'ng-hide'
      $(element).slideUp 'fast', doneFn

  removeClass: (element, className, doneFn) ->
    if className == 'ng-hide'
      $(element).slideDown 'fast', doneFn